export const CURRENT_LOCATION_FAIL = "CURRENT_LOCATION_FAIL";
export const CURRENT_LOCATION_SUCCESS = "CURRENT_LOCATION_SUCCESS";
